import Vue, { CreateElement } from 'vue';
import { VueConstructor } from 'vue/types/vue';
import VueCompositionApi from '@vue/composition-api';
import { hybrid } from '@kd/hybrid';
import HTTP from '../api/http';
import { logger } from 'kdlib/loggerh5';
import { getAppInfo } from 'kdlib/system';
import { urlExt } from 'kd-lib/packages/url';
// eslint-disable-next-line import/no-unresolved
import dirLogger from '@/directives/logger';
import { asyncJSLoader } from '@/utils/utils';

// 类型声明
/* eslint-disable @typescript-eslint/no-explicit-any */
declare module 'vue/types/vue' {
  interface Vue {
    api: any;
    $cmn: any;
    $http: any;
    $ajax: any;
    hybrid: any;
    logger: any;
    setData: any;
  }
  interface VueConstructor {
    api: any;
    $cmn: any;
    $http: any;
    $ajax: any;
    hybrid: any;
    logger: any;
    setData: any;
  }
}

declare global {
  interface Window {
    [key: string]: any;
  }
}

interface PageOptions {
  title?: string;
  component: any;
  beforeInit?(V: VueConstructor): void;
}

class Page {
  private instanceOptions: { [index: string]: unknown } = {};

  constructor(private options: PageOptions) {
    this.init();
  }

  async init(): Promise<void> {
    await this.commonInit();
    this.directiveInit();
    this.optionsInit();
    this.options.beforeInit && this.options.beforeInit(Vue);
    new Vue(this.instanceOptions).$mount('#app');
  }

  async commonInit(): Promise<void> {
    const appInfo = await getAppInfo(hybrid);
    Vue.use(VueCompositionApi);
    Vue.use(HTTP);
    Vue.$cmn = Vue.prototype.$cmn = appInfo;
    Vue.logger = Vue.prototype.logger = logger;
    Vue.hybrid = Vue.prototype.hybrid = hybrid;
    Vue.setData = (key: string, value: unknown) => {
      this.instanceOptions[key] = value;
    };
    // 兼容Android & iOS无故调用全局方法
    if (appInfo.os === 'ios') {
      /* eslint-disable @typescript-eslint/no-empty-function */
      !window.fePageDestroy && (window.fePageDestroy = () => {});
      !window.fePagePause && (window.fePagePause = () => {});
    }
  }

  directiveInit(): void {
    Vue.directive('log', dirLogger.loggerPV as any);
    Vue.directive('log-click', dirLogger.loggerClick as any);
  }

  optionsInit(): void {
    this.instanceOptions = {
      render: (h: CreateElement) => h('div', { attrs: { id: 'app' } }, [h(this.options.component)])
    };
  }
}

export default Page;
